import { InjectionToken } from '@angular/core';

export interface AppUpdateMessages {
  updateAvailable: string;
  reloadAction: string;
}

export interface AppUpdateConfig {
  checkIntervalMs: number;
  snackbarDurationMs: number;
  messages: AppUpdateMessages;
}

export const APP_UPDATE_CONFIG = new InjectionToken<Partial<AppUpdateConfig>>(
  'APP_UPDATE_CONFIG',
);
